var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("setup.finished.header")))]),
    _vm._v(" "),
    _c("div", { staticClass: "ct-card" }, [
      _c("section", { staticClass: "top-margin" }, [
        _c("div", {
          staticClass: "ct-text",
          domProps: {
            innerHTML: _vm._s(
              _vm.information.withWebsite &&
                _vm.information.cta &&
                _vm.information.cta.startsWith("cwb")
                ? _vm.$t("setup.finished.descriptionWebsite")
                : _vm.$t("setup.finished.description", {
                    email: _vm.information.email,
                    siteName: _vm.information.siteName
                  })
            )
          }
        })
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "ct-action" }, [
        _c("div", { staticClass: "ct-input-element" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              attrs: { href: _vm.siteUrl }
            },
            [_vm._v(_vm._s(_vm.$t("setup.finished.login")))]
          )
        ]),
        _vm._v(" "),
        _vm.information.country === "DE"
          ? _c("img", {
              staticStyle: { "border-style": "none" },
              attrs: {
                height: "1",
                width: "1",
                alt: "",
                src:
                  "//www.googleadservices.com/pagead/conversion/860296234/?label=uk81CJqN5HEQqqicmgM&guid=ON&script=0"
              }
            })
          : _vm.information.country === "GB"
          ? _c("img", {
              staticStyle: { "border-style": "none" },
              attrs: {
                height: "1",
                width: "1",
                alt: "",
                src:
                  "//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&guid=ON&script=0"
              }
            })
          : _vm.information.country === "BR"
          ? _c("img", {
              staticStyle: { "border-style": "none" },
              attrs: {
                height: "1",
                width: "1",
                alt: "",
                src:
                  "//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&guid=ON&script=0"
              }
            })
          : _c("img", {
              staticStyle: { "border-style": "none" },
              attrs: {
                height: "1",
                width: "1",
                alt: "",
                src:
                  "//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&guid=ON&script=0"
              }
            })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-083bf320", { render: render, staticRenderFns: staticRenderFns })
  }
}